import { useBrand } from '../context/BrandContext';
import FastestFormWorkflowList from './fastestform/WorkflowList';
import AbleWorkflowList from './able/WorkflowList';

export default function WorkflowList() {
  const { brand } = useBrand();
  return brand === 'able' ? <AbleWorkflowList /> : <FastestFormWorkflowList />;
}
